<template>
  <div>
    <h3 class="title-page">{{ $t("unreceivedProducts") }}</h3>
    <div class="admin_container">
      <div class="division_main">
        <div class="table_cover mobile_simple" style="overflow: auto">
          <TableWithFilter
            :headers="headers"
            :items.sync="productList"
            fixed-header
            item-key="id"
          >
            <template #filter.warehouseName>
              <div class="pa-1">
                <VueSelect
                  infinite
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getWareHouses', {
                        limit: 15,
                        name: text,
                        page: page,
                      })
                  "
                  @next-page-resolved="
                    (data) => setWarehouses([...warehouses, ...data])
                  "
                  @item-resolved="setWarehouses"
                  clearable
                  v-model="productFilter.warehouseId"
                  @input="getProductsByFilter"
                  :items="warehouses"
                  class="search_input user_input"
                />
              </div>
            </template>
            <template #filter.orderNumb>
              <div class="pa-1">
                <CustomInputText
                  only="number"
                  clearable
                  class="user_input no-margin"
                  @input="getProductsByFilter"
                  v-model="productFilter.orderNumb"
                  type="text"
                ></CustomInputText>
              </div>
            </template>
            <template #filter.productName>
              <div class="pa-1">
                <CustomInputText
                  clearable
                  class="user_input no-margin"
                  @input="getProductsByFilter"
                  v-model="productFilter.productName"
                  type="text"
                ></CustomInputText>
              </div>
            </template>
          </TableWithFilter>
        </div>
        <VuePagination
          v-model="configuration.page"
          :length="lastPage"
          @input="changePage"
          go-to
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "@/components/ui/vue-select/VueSelect";
const FilterOmtkUnreceivedProducts = {
  orderNumb: null,
  productName: null,
  warehouseId: null,
};

import {
  debounce,
  getQueryByKey,
  getQueryPage,
  makerPagination,
} from "@/utils/pureFunctions";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";

export default {
  name: "unreceived-products",
  components: {
    VueSelect,
    VuePagination,
    TableWithFilter,
  },
  data() {
    return {
      productFilter: {
        ...FilterOmtkUnreceivedProducts,
      },
      warehouses: [],
      productList: [],
      lastPage: 0,
      configuration: {
        total: 0,
        limit: 10,
        page: 1,
      },
    };
  },
  computed: {
    headers() {
      return [
        {
          value: "warehouseName",
          text: this.$t("sourceWarehouse"),
        },
        {
          value: "orderNumb",
          text: this.$t("numberRequest"),
        },
        {
          value: "productName",
          text: this.$t("productName"),
        },
        {
          value: "remains",
          text: this.$t("count"),
        },
        {
          value: "departmentName",
          text: this.$t("subdivision"),
        },

        {
          value: "createdByName",
          text: this.$t("userName"),
        },
        {
          value: "createdDate",
          text: this.$t("date"),
        },
      ];
    },
  },
  methods: {
    setWarehouses(warehouses) {
      this.warehouses = warehouses;
    },
    getProductsByFilter: debounce(async function () {
      this.showLoading();
      this.configuration.page = 1;
      await this.getGivenProductsList();
      await this.$router
        .replace({
          query: { page: this.configuration.page, ...this.productFilter },
        })
        .catch((err) => {
          console.warn(err);
        });
      this.clearLoading();
    }, 300),
    async changePage() {
      this.showLoading();
      await this.getGivenProductsList();
      await this.$router.replace({
        query: { page: this.configuration.page, ...this.productFilter },
      });
      this.clearLoading();
    },
    async getGivenProductsList() {
      let params = {
        ...this.productFilter,
        page: this.configuration.page - 1,
        limit: 10,
      };
      try {
        const {
          data: { data: ordersData, total: orderTotal },
        } = await this.$http.get("given-products/list", { params });
        this.productList = ordersData;
        this.lastPage = makerPagination({
          limit: params.limit,
          total: orderTotal,
        }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  async created() {
    const { query } = this.$route;
    this.configuration.page = getQueryPage(query.page);
    this.productFilter = getQueryByKey(FilterOmtkUnreceivedProducts, query);
    this.showLoading();
    await this.getGivenProductsList();
    this.clearLoading();
  },
};
</script>
